module.exports = __webpack_public_path__ + "media/assets/icons/eye-white-9b85f3cdfa251005942d4cf19d8fce1e.svg";